import { Pages } from 'interfaces/main';
import * as React from 'react';
import { Redirect } from 'react-router-dom';

const ToHomePage: React.FunctionComponent = () => {
    return <Redirect to={`/${Pages.DASHBOARD}`} />;
};

export default ToHomePage;
